import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useReducer, useMemo } from 'react';
import { ConfirmationModal, ModalActionTypes } from '@acorns/web-components';
import { mergeDefaults, customHandlerReducer, resolveName } from './handler';
export var ApolloErrorModalContext = /*#__PURE__*/React.createContext({});
export var ApolloErrorModalProvider = function ApolloErrorModalProvider(_ref) {
  var children = _ref.children,
      defaultErrorDetails = _ref.defaultErrorDetails;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var _useReducer = useReducer(customHandlerReducer, new Map()),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      customHandlerMap = _useReducer2[0],
      dispatch = _useReducer2[1];

  var closeErrorModal = function closeErrorModal() {
    return setShowModal(false);
  };

  var addCustomHandler = function addCustomHandler(name, handler, props) {
    dispatch({
      handler: handler,
      name: resolveName(name, props),
      type: 'add'
    });
  };

  var getCustomHandler = function getCustomHandler(name, props) {
    return customHandlerMap.get(resolveName(name, props));
  };

  var removeCustomHandler = function removeCustomHandler(name, props) {
    dispatch({
      name: resolveName(name, props),
      type: 'remove'
    });
  };

  var resolvedDefaults = _objectSpread({
    actions: [{
      handler: closeErrorModal,
      label: 'Try Again',
      type: ModalActionTypes.primary
    }],
    message: 'It looks like something went wrong.',
    title: 'Oops!'
  }, defaultErrorDetails);

  var _useState3 = useState(mergeDefaults(resolvedDefaults)),
      _useState4 = _slicedToArray(_useState3, 2),
      errorDetails = _useState4[0],
      setErrorDetails = _useState4[1];

  var showErrorModal = function showErrorModal(details) {
    setErrorDetails(mergeDefaults(resolvedDefaults, details));
    setShowModal(true);
  };

  var apolloErrorModalContext = useMemo(function () {
    return {
      addCustomHandler: addCustomHandler,
      getCustomHandler: getCustomHandler,
      removeCustomHandler: removeCustomHandler,
      closeErrorModal: closeErrorModal,
      showErrorModal: showErrorModal
    };
  }, []);
  return /*#__PURE__*/React.createElement(ApolloErrorModalContext.Provider, {
    value: apolloErrorModalContext
  }, children, /*#__PURE__*/React.createElement(ConfirmationModal, {
    zIndexOverride: 999,
    onRequestClose: closeErrorModal,
    actions: errorDetails.actions,
    eventFields: errorDetails.eventFields,
    image: errorDetails.image,
    message: errorDetails.message,
    isOpen: showModal,
    title: errorDetails.title
  }));
};